"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Happy = function Happy(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M48.013 78.026c-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.568 0 30 13.431 30 30 0 16.569-13.432 30-30 30zm-10-40c-3.341 0-5 3.893-5 7.5 0 1.642.213 2.5.937 2.5 1.493 0 2.076-1.25 4.063-1.25 1.986 0 2.569 1.25 4.062 1.25.724 0 .938-.858.938-2.5 0-3.607-1.659-7.5-5-7.5zm20 0c-3.341 0-5 3.893-5 7.5 0 1.642.213 2.5.937 2.5 1.493 0 2.076-1.25 4.063-1.25 1.986 0 2.568 1.25 4.062 1.25.724 0 .938-.858.938-2.5 0-3.607-1.659-7.5-5-7.5zm4.062 17.5c-1.734 0-5.153 5-14.063 5-8.909 0-12.328-5-14.062-5a.875.875 0 00-.938.938c0 1.614 5.624 9.062 15 9.062 9.377 0 15-7.448 15-9.062a.875.875 0 00-.937-.938z"
  }));
};

var _default = (0, _react.forwardRef)(Happy);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Happy, "Happy", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Happy.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Happy.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9IYXBweS50c3giXSwibmFtZXMiOlsiSGFwcHkiLCJwcm9wcyIsInJlZiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7O0FBRUEsSUFBTUEsS0FBcUUsR0FBRyxTQUF4RUEsS0FBd0UsQ0FBQ0MsS0FBRCxFQUFRQyxHQUFSLEVBQWdCO0FBQzVGLFNBQ0U7QUFBSyxJQUFBLEtBQUssRUFBRSxFQUFaO0FBQWdCLElBQUEsTUFBTSxFQUFFLEVBQXhCO0FBQTRCLElBQUEsT0FBTyxFQUFDO0FBQXBDLEtBQW9ERCxLQUFwRDtBQUEyRCxJQUFBLEdBQUcsRUFBRUM7QUFBaEUsTUFDRTtBQUNFLElBQUEsSUFBSSxFQUFDLGNBRFA7QUFFRSxJQUFBLENBQUMsRUFBQztBQUZKLElBREYsQ0FERjtBQVFELENBVEQ7O2VBV2UsdUJBQVdGLEtBQVgsQzs7Ozs7Ozs7Ozs7OzswQkFYVEEsSyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBSZWZGb3J3YXJkaW5nQ29tcG9uZW50LCBTVkdQcm9wcyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgSGFwcHk6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IHtcbiAgcmV0dXJuIChcbiAgICA8c3ZnIHdpZHRoPXs5Nn0gaGVpZ2h0PXs5Nn0gdmlld0JveD1cIjAgMCA5NiA5NlwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgICAgPHBhdGhcbiAgICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgICAgIGQ9XCJNNDguMDEzIDc4LjAyNmMtMTYuNTY5IDAtMzAtMTMuNDMxLTMwLTMwIDAtMTYuNTY5IDEzLjQzMS0zMCAzMC0zMCAxNi41NjggMCAzMCAxMy40MzEgMzAgMzAgMCAxNi41NjktMTMuNDMyIDMwLTMwIDMwem0tMTAtNDBjLTMuMzQxIDAtNSAzLjg5My01IDcuNSAwIDEuNjQyLjIxMyAyLjUuOTM3IDIuNSAxLjQ5MyAwIDIuMDc2LTEuMjUgNC4wNjMtMS4yNSAxLjk4NiAwIDIuNTY5IDEuMjUgNC4wNjIgMS4yNS43MjQgMCAuOTM4LS44NTguOTM4LTIuNSAwLTMuNjA3LTEuNjU5LTcuNS01LTcuNXptMjAgMGMtMy4zNDEgMC01IDMuODkzLTUgNy41IDAgMS42NDIuMjEzIDIuNS45MzcgMi41IDEuNDkzIDAgMi4wNzYtMS4yNSA0LjA2My0xLjI1IDEuOTg2IDAgMi41NjggMS4yNSA0LjA2MiAxLjI1LjcyNCAwIC45MzgtLjg1OC45MzgtMi41IDAtMy42MDctMS42NTktNy41LTUtNy41em00LjA2MiAxNy41Yy0xLjczNCAwLTUuMTUzIDUtMTQuMDYzIDUtOC45MDkgMC0xMi4zMjgtNS0xNC4wNjItNWEuODc1Ljg3NSAwIDAwLS45MzguOTM4YzAgMS42MTQgNS42MjQgOS4wNjIgMTUgOS4wNjIgOS4zNzcgMCAxNS03LjQ0OCAxNS05LjA2MmEuODc1Ljg3NSAwIDAwLS45MzctLjkzOHpcIlxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoSGFwcHkpO1xuIl19